// Phone invitations must bypass Cloud analytics and account-provider bootstrap.
if (/^\/race-cam\/phone\/?$/.test(window.location.pathname)) {
  import("./raceCam/phoneEntry");
} else {
  import("./cloudBootstrap");
}
